import { render } from "./AudioWave.vue?vue&type=template&id=710857f6&scoped=true"
const script = {}

import "./AudioWave.vue?vue&type=style&index=0&id=710857f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710857f6"]])

export default __exports__